import React from "react";
import { Form, FormGroup, FormControl } from "rsuite";
import Icon from "rsuite/es/Icon";

import { toStartDayUTCTime } from "utils";
import ColorBadge from "components/base/ColorBadge";
import {
    applyValidationErrors,
    replaceByIndex,
    removeByIndex,
} from "./TrunkFormRefactored.utils";
import {
    Header,
    StyledGrid,
    StyledList,
    StyledListItem,
    StyledStatusIndexContainer,
    AddNewButton,
} from "./TrunkFormRefactored.styles";

const IpListSection = ({
    isMobile,
    ipList,
    ipFormRef,
    formSupplierModel,
    setError,
    setIpList,
    protocolTypeValues,
}) => {
    return <>
        <Header ml={50} mb={20}>IP List</Header>

        <StyledGrid
            isMobile={isMobile}
            style={{ margin: 0, marginLeft: 30 }}
            showBorder={ipList.length > 3}
            className="list-container"
        >
            <StyledList>
                {ipList.map((ipValue, idx) => {
                    const statusColor = ipValue.bound ? "var(--color-success)" : "var(--color-error2)";
                    const currentIpValue = { ...ipValue, options: ipValue?.option_list ? ipValue.option_list.map(value => value.key) : [] };

                    return (<StyledListItem>
                        <Form
                            key={ipValue.key}
                            ref={ref => ipFormRef[ipValue.key] = ref}
                            model={formSupplierModel}
                            onChange={(value) => {

                                const checkedFormValue = formSupplierModel.check(value);

                                const ipValueKey = ipValue.key || `new_${idx}`;
                                applyValidationErrors(setError, "ipErrors", ipValueKey, checkedFormValue);
                                setIpList(prev => {
                                    const nextValue = {
                                        ...value,
                                        ...(value?.port ? { port: value.port } : {}),
                                        ...(value?.start_date ? { start_date: toStartDayUTCTime(new Date(value?.start_date)) } : {}),
                                        ...(value?.end_date ? { end_date: toStartDayUTCTime(new Date(value?.end_date)) } : {})
                                    };

                                    return replaceByIndex(prev, idx, nextValue);
                                });
                            }}
                            formDefaultValue={{ ...currentIpValue }}
                        >
                            <FormGroup>
                                <StyledStatusIndexContainer>
                                    {ipValue?.key && <span className="status">
                                        <ColorBadge badgeColor={statusColor} />
                                    </span>}
                                    <span className="index">{idx + 1}</span>
                                </StyledStatusIndexContainer>
                                <FormControl
                                    name="ip"
                                    placeholder="IP Address..."
                                    style={{ width: 165 }}
                                    value={ipValue.ip}
                                    onChange={() => {
                                    }}
                                />
                                {protocolTypeValues.smpp_mo && <FormControl
                                    name="port"
                                    placeholder="Port..."
                                    style={{ width: 120 }}
                                    value={ipValue.port}
                                />}
                            </FormGroup>
                            <Icon
                                onClick={() => {
                                    const newList = removeByIndex(ipList, idx);

                                    setIpList(newList);
                                }}
                                className="delete"
                                icon="trash"
                            />
                        </Form>
                    </StyledListItem>);
                })}
                <AddNewButton
                    ml={70}
                    appearance="ghost"
                    onClick={() => {
                        const newList = [...ipList];
                        newList.push({ ip: "", start_date: null, end_date: null });
                        setIpList(newList);
                    }}
                >
                    <Icon icon="plus" /> Add new{ipList && !ipList.length ? " ip" : ""}
                </AddNewButton>
            </StyledList>
        </StyledGrid>
    </>;
};

export default IpListSection;
